import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';

export interface EmspBoLocationCpoIdFilterStateControllerProps {
  value: string;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoLocationCpoIdFilterStateController = ({
  value,
  onRemove,
}: EmspBoLocationCpoIdFilterStateControllerProps): React.JSX.Element => (
  <FilteredItem icon="wifi" label={value} onRemove={onRemove} />
);
